import { FeatureDefinition } from "./types";

const features: FeatureDefinition[] = [];

export function registerFeature(feature: FeatureDefinition): void {
  if (!features.find((f) => f.id === feature.id)) {
    features.push(feature);
  }
}

export function getFeatures(): FeatureDefinition[] {
  return features;
}
